/* eslint-disable */
// Missing alot of kendo typings
export default class EditorToolFunctions {
    static openInsertBase64Image(se) {
        const element = $(se.sender.element);
        const editorElement = element.closest(".kendo-text-editor-wrapper").find(".k-editor");
        const editor = editorElement.data("kendoEditor") || editorElement.data("kendoOrphyEditor");
        const action = $(editor.element).data("uploadbase64image");
        const windowWrapper = `<div class='insertBase64ImageWrapper' data-editorid='${editorElement[0].id}'></div>`;
        const window = $(windowWrapper)
            .kendoWindow({
            modal: true,
            resizable: false,
            title: "Upload",
            open(e) {
                kendo.ui.progress(e.sender.element, true);
            },
            refresh(e) {
                window.center().open();
                kendo.ui.progress(e.sender.element, false);
            },
            // remove the Window from the DOM after closing animation is finished
            deactivate(e) { e.sender.destroy(); }
        }).data("kendoWindow");
        window.setOptions({
            width: 480,
            height: 355
        });
        window.refresh({ url: action });
    }
    static changeParagraphToBr() {
        //use <br> instead of <p>
        const defaultTools = (kendo.ui.Editor).defaultTools;
        defaultTools["insertLineBreak"].options.shift = false;
        defaultTools["insertParagraph"].options.ctrl = false;
        defaultTools["insertParagraph"].options.shift = true;
    }
    static initializeEditor(kendoEditor) {
        const wrapperId = `.${kendoEditor.element[0].id}_wrapper`;
        // add class to hide toolbar
        const toolbar = $(kendoEditor.toolbar.element).closest(".k-window.k-window-titleless");
        toolbar.addClass("hideToolbarWindow");
        kendoEditor.toolbar.show();
        $(kendoEditor.body).addClass("k-state-active").off("focusout.kendoEditor");
        if (kendoEditor.toolbar) {
            let toolbar = $(kendoEditor.toolbar.element);
            let toolbarWindow = $(toolbar).closest(".k-window");
            $(wrapperId).wrapAll('<div class="kendo-text-editor-wrapper"></div>');
            let wrapper = $(wrapperId).closest(".kendo-text-editor-wrapper");
            wrapper.prepend(toolbar);
            toolbarWindow.detach();
        }
        //disable floating style -> kendo will set height to 100% and restore it on those events usualy
        const mouseover = kendoEditor._handlers.find((r) => r.type === "mouseover.kendoEditor");
        const dragenter = kendoEditor._handlers.find((r) => r.type === "dragenter.kendoEditor");
        const mouseout = kendoEditor._handlers.find((r) => r.type === "mouseout.kendoEditor");
        const dragleave = kendoEditor._handlers.find((r) => r.type === "dragleave.kendoEditor");
        if (mouseover) {
            mouseover.element.off(mouseover.type, mouseover.handler);
        }
        if (dragenter) {
            dragenter.element.off(dragenter.type, dragenter.handler);
        }
        if (mouseout) {
            mouseout.element.off(mouseout.type, mouseout.handler);
        }
        if (dragleave) {
            dragleave.element.off(dragleave.type, dragleave.handler);
        }
    }
    static postInlieEditorOnSubmit(editorId) {
        $("form").on("submit", (event) => {
            const form = $(event.target);
            const editorElement = form.find(`#${editorId}`);
            EditorToolFunctions.createInputForEditor(editorElement, form, true);
        });
    }
    static postInlieEditorNotEncodedOnSubmit(editorId) {
        $("form").on("submit", (event) => {
            const form = $(event.target);
            const editorElement = form.find(`#${editorId}`);
            EditorToolFunctions.createInputForEditor(editorElement, form, false);
        });
    }
    static createInputForEditor(editorElement, form, encoded) {
        if (editorElement && editorElement.length > 0) {
            const editor = editorElement.data("kendoOrphyEditor") || editorElement.data("kendoEditor");
            const value = encoded ? editor.encodedValue() : editor.value();
            form.find($(`input[name='${editor.element.attr("name")}']`)).remove();
            $("<input type='hidden' />").attr("name", editor.element.attr("name")).val(value).insertAfter(editorElement);
        }
    }
}
